<template>
    <div class="container pt-4" style="max-width: 600px; padding-bottom: 150px;">
        <div class="card">
            <h4 class="card-header p-3">Registration</h4>
            <div class="card-body">
                <div class="p-4">
                    <div class="mb-4 text-center"><b>Already have an account? <router-link to="login">Sign In</router-link></b></div>
                    <div class="mb-3">
                        <input v-model="firstName" type="text" class="form-control" id="firstName"
                            placeholder="First Name">
                    </div>
                    <div class="mb-3">
                        <input v-model="middleName" type="text" class="form-control" id="middleName"
                            placeholder="Middle Name">
                    </div>
                    <div class="mb-3">
                        <input v-model="lastName" type="text" class="form-control" id="lastName"
                            placeholder="Last Name">
                    </div>
                    <div class="mb-1">
                        <select v-model="staffType" class="form-control" id="exampleFormControlInput3"
                            name="Staff Type" @change="setPresentStatus()" disabled>
                            <option selected value="Academic Teaching">Academic Teaching Staff</option>
                        </select>
                    </div>

                    <select v-if="(staffType == 'Senior Non-academic') || (staffType == 'Junior Non-academic')" id="faculty" name="faculty" v-model="faculty">
                        <option value="faculty" selected>Faculty/Institute/Directorate/Center</option>
                        <option value="Agriculture">Agriculture</option>
                        <option value="Basic Medical Sciences">Basic Medical Sciences</option>
                        <option value="Basic Clinical Sciences">Basic Clinical Sciences</option>
                        <option value="Clinical Sciences">Clinical Sciences</option>
                        <option value="Medical Laboratory Science">Medical Laboratory Science</option>
                        <option value="Communication and Media Studies">Communication and Media Studies</option>
                        <option value="Engineering">Engineering</option>
                        <option value="Education">Education</option>
                        <option value="Environmental Sciences">Environmental Sciences</option>
                        <option value="Humanities">Humanities</option>
                        <option value="Law">Law</option>
                        <option value="Administration and Management">Administration and Management</option>
                        <option value="Science">Science</option>
                        <option value="Insitute of Education">Institute of Education</option>
                        <option value="Rivers Institute of Agricultural Research & Training">Rivers Institute of Agricultural Research & Training</option>
                        <option value="Centre for Open and Distance Learning">Centre for Open and Distance Learning</option>
                        <option value="Institute Of Geo-sciences And Environmental Management">Institute Of Geo-sciences And Environmental Management</option>
                        <option value="Institute of Pollution Studies">Institute of Pollution Studies</option>
                        <option value="Centre for Climate Change & Forest Resources">Social Sciences</option>
                        <option value="Centre for Advance Law Research">Centre for Advance Law Research</option>
                        <option value="Centre for Water & Sanitation Studies">Centre for Water & Sanitation Studies</option>
                        <option value="Advancement and Linkage Centre profile">Advancement and Linkage Centre profile</option>
                        <option value="Centre for Continuing Education">Centre for Continuing Education</option>
                        <option value="Centre Of Excellence In Marine Offshore Engineering">Centre Of Excellence In Marine Offshore Engineering</option>
                        <option value="Information and Communication Technology Centre (ICTC)">Information and Communication Technology Centre (ICTC)</option>
                        <option value="Directorate of Alumni Relations">Directorate of Alumni Relations</option>
                        <option value="Directorate of Physical Planning">Directorate of Physical Planning</option>
                        <option value="Directorate of Research and Development">Directorate of Research and Development</option>
                        <option value="Directorate of Pre-Degree Programme">Directorate of Pre-Degree Programme</option>
                        <option value="Directorate of Establishment">Directorate of Establishment</option>
                        <option value="Directorate of Students Affairs">Directorate of Students Affairs</option>
                        <option value="Directorate of Quality Assurance">Directorate of Quality Assurance</option>
                        <option value="Directorate of Academic Planning">Directorate of Academic Planning</option>
                        <option value="University Library">University Library</option>
                        <option value="Consultancy Services Unit">Consultancy Services Unit</option>
                        <option value="Guidiance and Counselling Unit">Social Sciences</option>
                        <option value="Foundation Studies Unit">Foundation Studies Unit</option>
                        <option value="Medical Centre">Medical Centre</option>
                        <option value="Information/Publication/Protocol Unit">Information/Publication/Protocol Unit</option>
                        <option value="Intellectual Property and Technology Transfer Office">Intellectual Property and Technology Transfer Office</option>
                        <option value="The Registry">The Registry</option>
                        <option value="Students' Industrial Work Experience Scheme (SIWES) Unit">Students' Industrial Work Experience Scheme (SIWES) Unit</option>
                        <option value="University Security Unit">University Security Unit</option>
                        <option value="Estate, Works and Transport">Estate, Works and Transport</option>
                        <option value="Others">Others</option>
                    </select>

                    <div class="mb-1" v-if='staffType == "Academic Teaching"'>
                        <div class="text-start">
                            <select id="faculty" name="faculty" v-model="faculty">
                                <option value="faculty" selected>Faculty</option>
                                <option value="Agriculture">Agriculture</option>
                                <option value="Basic Medical Sciences">Basic Medical Sciences</option>
                                <option value="Basic Clinical Sciences">Basic Clinical Sciences</option>
                                <option value="Clinical Sciences">Clinical Sciences</option>
                                <option value="Medical Laboratory Science">Medical Laboratory Science</option>
                                <option value="Communication and Media Studies">Communication and Media Studies</option>
                                <option value="Engineering">Engineering</option>
                                <option value="Education">Education</option>
                                <option value="Environmental Sciences">Environmental Sciences</option>
                                <option value="Humanities">Humanities</option>
                                <option value="Law">Law</option>
                                <option value="Administration and Management">Administration and Management</option>
                                <option value="Science">Science</option>
                                <option value="Social Sciences">Social Sciences</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <select v-if="staffType == 'Senior Non-academic'" id="staffCadre" name="staffCadre" v-model="staffCadre">
                            <option value="staffCadre">Staff Cadre</option>
                            <option value="Registry">Registry - Administrative Officers Cadre</option>
                            <option value="Executive">Executive Officers Cadre</option>
                            <option value="Sec">Secretaries Cadre</option>
                            <option value="Info">Information and Public Relations Officers Cadre</option>
                            <option value="Legal">Legal Officers Cadre</option>
                            <option value="Secretarial">Secretarial Assistant/Data processing Officer Cadre</option>
                            <option value="Pharmacists">Pharmacists Cadre</option>
                            <option value="Nursing">Nursing Cadre</option>
                            <option value="Medical">Medical Doctor's Cadre</option>
                            <option value="Health">Health Technician's Cadre</option>
                            <option value="Radiographer">Radiographer's Cadre</option>
                            <option value="Bursary">Bursary Staff - Accountant's Cadre</option>
                            <option value="Executive Accounts">Executive Officers (Accounts) Cadre</option>
                            <option value="Internal">Internal Auditor's Cadre</option>
                            <option value="Stores">Stores Cadre</option>
                            <option value="Security">Security Officer Cadre</option>
                            <option value="Library">Library (Sub-Professional Staff) Cadre</option>
                            <option value="Bindery">Bindery Staff Cadre</option>
                            <option value="Teaching Farm">Teaching Farm Officers Cadre</option>
                            <option value="Premises">Premises/Housekeepers Cadre</option>
                            <option value="Catering">Catering Officers Cadre</option>
                            <option value="Computer">Computer Professional Cadre</option>
                            <option value="Teacher">Teachers Cadre</option>
                            <option value="Technologist">Technologist Cadre</option>
                            <option value="Lab">Laboratory Scientist Cadre</option>
                            <option value="Sports">Sports Cadre</option>
                            <option value="Estate">Estate, Works & Transport (Engineers) Cadre</option>
                            <option value="Maintenance">Maintenance Officers/Other Professionals Cadre</option>
                            <option value="Technician">Technician Cadre (Technical Officers)</option>
                            <option value="Motor">Motor/Tractor Drivers and Mechanics Cadre</option>
                            <option value="Environmental">Environmental/Public Health Officer/Community Health Education Worker
                                Cadre</option>
                        </select>
                        <select v-if="staffType == 'Junior Non-academic'" id="staffCadre" name="staffCadre" v-model="staffCadre">
                            <option value="staffCadre">Staff Cadre</option>
                            <option value="Registry" selected>Registry Department (Clerical Cadre)</option>
                            <option value="Cleaner">Cleaner Cadre</option>
                            <option value="Secretarial">Secretarial Assistants (i.e. Typists) Cadre</option>
                            <option value="Computer">Computer Operator Cadre</option>
                            <option value="Audit">Audit Cadre</option>
                            <option value="Store">Store Cadre</option>
                            <option value="Accounts">Accounts Cadre</option>
                            <option value="Catering">Catering Cadre</option>
                            <option value="Halls">Halls of Residence</option>
                            <option value="Health">Health Services Department (Medical Records Cadre)</option>
                            <option value="Pharmacy">Pharmacy Assistant Cadre</option>
                            <option value="Health Assistant">Health Assitant Cadre</option>
                            <option value="Washerman">Washerman Cadre</option>
                            <option value="Library">Library Department</option>
                            <option value="Bindery">Bindery/Printing Cadre</option>
                            <option value="Audio">Audio-Visual Cadre</option>
                            <option value="Security">Security Department</option>
                            <option value="Environmental">Environmental Sciences (Technical Cadre)</option>
                            <option value="Engineering">Engineering, Science (Technical Cadre)</option>
                            <option value="Marine">Marine Engineering Department (Technician Cadre)</option>
                            <option value="Estate">Estate, Works and Transport Department (Labour/Gardener) Cadre</option>
                            <option value="Technical">Technical Cadre</option>
                            <option value="Drivers">Drivers Cadre</option>
                            <option value="Divers Mate">Drivers Mate Cadre</option>
                            <option value="Tractor">Tractor Drivers' Cadre</option>
                            <option value="Tractor Mate">Tractor Drivers' Mate Cadre</option>
                            <option value="Stores">Stores Cadre (Estate, Works and Transport Department)</option>
                            <option value="Store Attendant">Store Attendant (Estate, Works and Transport Department)</option>
                            <option value="Agriculture">Faculty of Agriculture (Technical Cadre)</option>
                            <option value="Labourer">Labourer Cadre (Faculty of Agriculture)</option>
                            <option value="Science">Science Laboratory Cadre</option>
                            <option value="Nursery">Nursery Attendants for the Staff School</option>
                        </select>
                    </div>

                    <div class="mb-3" v-if='staffType == "Academic Teaching"'>
                        <div class="text-start">
                            <div>
                                <select id="presentStatus" name="presentStatus" v-model="presentStatus">
                                    <option value="presentStatus">Present Status</option>
                                    <option value="Professor">Professor</option>
                                    <option value="Reader">Reader</option>
                                    <option value="Senior Lecturer">Senior Lecturer</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3" v-if='staffType == "Research"'>
                        <div class="text-start">
                            <div>
                                <select id="presentStatus" name="presentStatus" v-model="presentStatus">
                                    <option value="presentStatus">Present Status</option>
                                    <option value="Research Professor">Research Professor</option>
                                    <option value="Research Reader">Research Reader</option>
                                    <option value="Senior Research Fellow">Senior Research Fellow</option>
                                    <option value="Research Fellow I">Research Fellow I</option>
                                    <option value="Research Fellow II">Research Fellow II</option>
                                    <option value="Assistant Research Fellow">Assistant Research Fellow</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3" v-if='staffType == "Library"'>
                        <div class="text-start">
                            <div>
                                <select id="presentStatus" name="presentStatus" v-model="presentStatus">
                                    <option value="presentStatus">Present Status</option>
                                    <option value="University Librarian">University Librarian</option>
                                    <option value="Deputy Librarian">Deputy Librarian</option>
                                    <option value="Principal Librarian">Principal Librarian</option>
                                    <option value="Senior Librarian">Senior Librarian</option>
                                    <option value="Librarian I">Librarian I</option>
                                    <option value="Librarian II">Librarian II</option>
                                    <option value="Assistant Librarian">Assistant Librarian</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div>
                        <input v-model="email" type="text" class="form-control" id="exampleFormControlInput7"
                            placeholder="Email">
                    </div>
                    <div class="input-group mb-3">
                        <input v-if="!viewPassword" type="password" class="form-control" id="exampleFormControlInput6" placeholder="Password" v-model="password">
                        <input v-if="viewPassword" type="text" class="form-control" id="exampleFormControlInput6" placeholder="Password" v-model="password">
                        <span v-if="!viewPassword" @click="togglePassword()" class="input-group-text" id="basic-addon2" style="border: none; border-radius: 10px;"><i style="color: grey;" class="fa-solid fa-eye"></i></span>
                        <span v-if="viewPassword" @click="togglePassword()" class="input-group-text" id="basic-addon2" style="border: none; border-radius: 10px;"><i style="color: grey;" class="fa-solid fa-eye-slash"></i></span>
                    </div>
                    <div class="mb-3">
                        <input type="password" class="form-control" id="exampleFormControlInput4"
                            placeholder="Confirm Password" v-model="confirmPassword">
                    </div>
                </div>
                <div class="justify-content-center">
                    <button @click="getCandidate()" type="button" class="btn btn-success">Register</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DataService from '../services/dataservice'

export default {
    name: 'register',
    emits: ['toggleLoader'],
    data() {
        return {
            email: '',
            firstName: '',
            middleName: '',
            lastName: '',
            loading: false,
            staffType: 'Academic Teaching',
            faculty: 'faculty',
            staffCadre: 'staffCadre',
            presentStatus: 'presentStatus',
            password: '',
            confirmPassword: '',
            viewPassword: false
        }
    },
    mounted(){
        this.initialize()
    },
    methods: {
        togglePassword(){
            this.viewPassword = this.viewPassword == false ? true : false
        },
        async getCandidate() {
            this.$emit('toggleLoader');

            if (this.email) {
                var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\. \-]+\.[a-zA-z0-9]{2,4}$/;
                if (this.email.match(regex) == null){
                    alert ('Enter a correct email');
                    this.$emit('toggleLoader');
                    return
                }

                this.firstName = this.firstName.trim()
                this.middleName = this.middleName.trim()
                this.lastName = this.lastName.trim()

                if (!this.firstName || !this.lastName) {
                    alert('Fill your first name and last name');
                    this.$emit('toggleLoader');
                    return
                }

                if (this.staffType == 'Staff Type') {
                    alert('Choose a staff type');
                    this.$emit('toggleLoader');
                    return
                } 
                
                if (this.staffType == 'Academic Teaching' && this.faculty == 'faculty') {
                    alert('Choose a faculty');
                    this.$emit('toggleLoader');
                    return
                }

                if ((this.staffType == 'Senior Non-academic' || this.staffType == 'Junior Non-academic') && this.staffCadre == 'staffCadre') {
                    alert('Choose a staff cadre');
                    this.$emit('toggleLoader');
                    return
                }

                if ((this.staffType == 'Academic Teaching' || this.staffType == 'Research' || this.staffType == 'Library') && (this.presentStatus == 'presentStatus')) {
                    alert('Choose present status');
                    this.$emit('toggleLoader');
                    return
                }

                if (!this.password || !this.confirmPassword) {
                    alert('Please enter and confirm password');
                    this.$emit('toggleLoader');
                    return
                }

                if (this.password != this.confirmPassword) {
                    alert('Passwords do not match');
                    this.$emit('toggleLoader');
                    return
                }
                

                this.loading = true;

                var details = {
                    name: `${this.firstName}${this.middleName ? ' ' : ''}${this.middleName} ${this.lastName}`,
                    email: this.email.trim().toLowerCase(), 
                    staffType: this.staffType,
                    faculty: this.faculty,
                    staffCadre: this.staffCadre,
                    presentStatus: this.presentStatus,
                    password: this.password
                }

                const user = await DataService.register(details);

                if (user) {
                    this.$store.commit('connect', {_id: user.details._id, staffType: user.details.staffType, token: user.token});

                    this.$emit('toggleLoader');

                    if (user.details.staffType == 'Academic Teaching' || user.details.staffType == 'Research' || user.details.staffType == 'Library') {
                        this.$router.push({ path: '/sectiona' });
                    } else {
                        this.$router.push({ path: '/section1' });
                    }
                } else {
                    this.$emit('toggleLoader')
                }
            } else {
                alert('Fill the email field')
                this.$emit('toggleLoader');
            }
            
        },
        setPresentStatus() {
            this.presentStatus = 'presentStatus'
        },
        initialize() {
            if (DataService.isLoggedIn()) {
                this.$router.push({ path: `/` });
            }
        }
    }
}
</script>
